export const replaceSpaces = (
  value: string,
  replaceValue: string = '_'
): string => value.replace(/ /g, replaceValue);

export const toCapitalCase = (str: string): string =>
  str
    .toLowerCase()
    .replace(/(?:\b)(\w)/g, (_, firstChar) => firstChar.toUpperCase());

export const base64ToUtf8 = (str: string) => {
  try {
    return decodeURIComponent(encodeURIComponent(window.atob(str)));
  } catch (e) {
    console.warn(e);
  }
  return '';
};
